<template>
    <v-card>
        <v-card-title>
            Recent Courses/Certificates
        </v-card-title>
        <v-card-text>
            <v-carousel show-arrows="hover" continuous hide-delimiter-background height="400px" progress="primary"
                v-model="certificateSlide" v-if="certifications.length > 0">
                <v-carousel-item v-for="(cert, i) in certifications" :key="i">
                    <div class="d-flex flex-column pa-2 align-center justify-center">
                        <v-img :src="cert.string01" width="100%" height="250px" />
                        <div class="text-h5 font-weight-bold text-center">{{ cert.description }}</div>
                        <div class="text-h6 font-weight-bold text-center">{{ cert.string02 }}</div>
                    </div>
                </v-carousel-item>
            </v-carousel>
        </v-card-text>
    </v-card>
    <v-card class="mt-5 mb-2">
        <v-card-title>
            <v-btn @click="showForm = true" v-if="!showForm">Add</v-btn>
        </v-card-title>
        <v-card-text>
            <v-form v-if="showForm">
                <v-row>
                    <v-col>
                        <p>Qualification Type</p>
                        <v-autocomplete :items="qualificationTypes" v-model="qualification.qualificationType" />

                        <p>Qualification</p>
                        <v-text-field v-model="qualification.qualification" />

                        <p>Institute Name</p>
                        <v-text-field v-model="qualification.instituteName" />

                        <p>Start Date</p>
                        <v-text-field v-model="qualification.startDate" />

                        <p>End Date</p>
                        <v-text-field v-model="qualification.endDate" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col align="end">
                        <v-btn variant="text">Cancel</v-btn>
                        <v-btn>Save</v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-text>
            <data-table :tableData="tableData"></data-table>
        </v-card-text>
    </v-card>
</template>

<script setup>
import { ref, reactive, onMounted, inject } from 'vue';
import * as utService from '@/services/utilitiesService';

const loader = inject("loader");
// const snackbar = inject("snackBar");

const qualificationTypes = ['Primary', 'Secondary', 'Matric/O-Level', 'Intermediate/A-Level', 'Degree', 'Diploma', 'Certificate'];

const certifications = ref([]);
const certificateSlide = ref(0);
const showForm = ref(false);

const tableData = reactive({
    headers: [
        { title: "S. No", key: "SNo" },
        { title: "Type", key: "qualificationType" },
        { title: "Qualification", key: "qualification" },
        { title: "Institute", key: "instituteName" },
        { title: "Start Date", key: "startDate" },
        { title: "End Date", key: "endDate" },
        { title: "Certificate", key: "filePath" },
        { title: "Actions", key: "Actions" },
    ],
    data: [],
    itemsPerPage: 999,
    totalItems: 0,
    paginationContext: {},
});

const qualification = ref({
    qualificationType: '',
    qualification: '',
    instituteName: '',
    startDate: '',
    endDate: '',
    filePath: '',
});

onMounted(async () => {

    const promises = [utService.getGeneralsById(53)];

    loader.show();

    const [getCertifications] = await Promise.all(promises);
    certifications.value = getCertifications;

    loader.hide();

});

</script>